import { render } from "./ListBans.vue?vue&type=template&id=0ed4d9fb&ts=true"
import script from "./ListBans.vue?vue&type=script&lang=ts"
export * from "./ListBans.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Special/ListBans.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ed4d9fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ed4d9fb', __exports__)) {
    api.reload('0ed4d9fb', __exports__)
  }
  
  module.hot.accept("./ListBans.vue?vue&type=template&id=0ed4d9fb&ts=true", () => {
    api.rerender('0ed4d9fb', render)
  })

}


export default __exports__